export var IType;
(function(IType) {
    IType[IType["TEXT"] = 0] = "TEXT";
    IType[IType["PRODUCT"] = 1] = "PRODUCT";
})(IType || (IType = {}));
